import { preferenceKeyForUser } from 'common/constants/userPreferences';
import { REACT_QUERY_CACHE_SCHEMA_VERSION } from './reactQueryIndexedDBPersister.constants';

interface ReactQueryCacheBusterOptions {
  apiEndpoint?: string;
  userId?: number | null;
}

const normalizeApiEndpoint = (apiEndpoint?: string): string =>
  apiEndpoint?.trim().replaceAll(/\/+$/g, '') || 'same-origin';

export const buildReactQueryCacheBuster = ({ apiEndpoint, userId }: ReactQueryCacheBusterOptions): string => {
  const cacheNamespace = [`react-query-v${REACT_QUERY_CACHE_SCHEMA_VERSION}`, normalizeApiEndpoint(apiEndpoint)].join(
    '|'
  );

  return userId == null ? `${cacheNamespace}:anonymous` : preferenceKeyForUser(cacheNamespace, userId);
};
